// Input de una sola línea con el botón de dictado — mismo patrón que AreaDictado
// pero para campos de texto libre cortos (no áreas). Sin botón si el campo es de
// solo lectura/calculado: no tiene sentido dictar sobre un valor que el usuario no edita.
import type { JSX } from 'react';
import { BotonDictado } from '@/components/BotonDictado';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export function CampoDictado({
  id,
  etiqueta,
  valor,
  onChange,
  soloLectura,
  placeholder,
}: {
  readonly id: string;
  readonly etiqueta: string;
  readonly valor: string;
  readonly onChange: (v: string) => void;
  readonly soloLectura?: boolean;
  readonly placeholder?: string;
}): JSX.Element {
  return (
    <div className="flex flex-col gap-1">
      <Label htmlFor={id}>{etiqueta}</Label>
      {soloLectura ? (
        <Input id={id} readOnly value={valor} placeholder={placeholder} />
      ) : (
        <div className="flex items-center gap-2">
          <Input id={id} className="flex-1" value={valor} placeholder={placeholder} onChange={(e) => onChange(e.target.value)} />
          <BotonDictado onTranscrito={(texto) => onChange(valor ? `${valor} ${texto}` : texto)} />
        </div>
      )}
    </div>
  );
}
